var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('van-nav-bar',{staticClass:"about_nav_bar",style:('background: #ff5000; color:#FFFFFF;'),attrs:{"border":false,"left-arrow":"","fixed":"","title":_vm.document.title,"z-index":20},on:{"click-left":_vm.onClickLeft}}),_c('p',{staticClass:"center-b",domProps:{"innerHTML":_vm._s(_vm.document.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }